export enum AccountStatusKind {
    PENDING_CONFIRM_EMAIL = 0,
    ENABLED = 1,
    EXPIRED = 2,
    SUSPENDED = 3
}
